import { render, staticRenderFns } from "./system-set.vue?vue&type=template&id=1df4dc5e&scoped=true&"
import script from "./system-set.vue?vue&type=script&lang=js&"
export * from "./system-set.vue?vue&type=script&lang=js&"
import style0 from "./system-set.vue?vue&type=style&index=0&id=1df4dc5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df4dc5e",
  null
  
)

export default component.exports